import { NavLink } from "@/components/NavLink";
import { Phone, Mail, Facebook, Linkedin, Twitter } from "lucide-react";

export const Footer = () => {
  const shareUrl = "https://www.leafrushmarketing.com";
  const shareText = "Lawn Care & Landscaping Websites That Get Clients";

  return (
    <footer className="border-t bg-muted/30">
      <div className="container px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-8 md:grid-cols-4">
          <div className="space-y-4">
            <p className="text-lg font-bold text-primary">Leaf Rush Marketing</p>
            <p className="text-sm text-muted-foreground">
              Done-for-you lawn care & landscaping website design that gets you more calls, quotes, and recurring clients.
            </p>
            {/* Social Sharing */}
            <div className="flex gap-3 pt-2">
              <a
                href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-primary transition-colors"
                aria-label="Share on Facebook"
              >
                <Facebook size={20} />
              </a>
              <a
                href={`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(shareUrl)}&title=${encodeURIComponent(shareText)}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-primary transition-colors"
                aria-label="Share on LinkedIn"
              >
                <Linkedin size={20} />
              </a>
              <a
                href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareText)}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-primary transition-colors"
                aria-label="Share on X"
              >
                <Twitter size={20} />
              </a>
            </div>
          </div>

          <div className="space-y-4">
            <p className="text-sm font-semibold">Website Design</p>
            <nav className="flex flex-col space-y-2 text-sm">
              <NavLink to="/lawn-care-website-design" className="text-muted-foreground hover:text-foreground transition-colors">
                Lawn Care Website Design
              </NavLink>
              <NavLink to="/landscaping-website-design" className="text-muted-foreground hover:text-foreground transition-colors">
                Landscaping Website Design
              </NavLink>
              <NavLink to="/websites" className="text-muted-foreground hover:text-foreground transition-colors">
                Website Design Pricing
              </NavLink>
              <NavLink to="/growth-add-ons/google-ads" className="text-muted-foreground hover:text-foreground transition-colors">
                Google Ads
              </NavLink>
              <NavLink to="/growth-add-ons/gbp" className="text-muted-foreground hover:text-foreground transition-colors">
                GBP Optimization
              </NavLink>
            </nav>
          </div>

          <div className="space-y-4">
            <p className="text-sm font-semibold">Company</p>
            <nav className="flex flex-col space-y-2 text-sm">
              <NavLink to="/about" className="text-muted-foreground hover:text-foreground transition-colors">
                About Us
              </NavLink>
              <NavLink to="/lawn-care-seo" className="text-muted-foreground hover:text-foreground transition-colors">
                Lawn Care SEO
              </NavLink>
              <NavLink to="/resources" className="text-muted-foreground hover:text-foreground transition-colors">
                Resources
              </NavLink>
              <NavLink to="/contact" className="text-muted-foreground hover:text-foreground transition-colors">
                Contact
              </NavLink>
            </nav>
          </div>

          <div className="space-y-4">
            <p className="text-sm font-semibold">Legal</p>
            <nav className="flex flex-col space-y-2 text-sm">
              <NavLink to="/privacy-policy" className="text-muted-foreground hover:text-foreground transition-colors">
                Privacy Policy
              </NavLink>
              <NavLink to="/terms-of-service" className="text-muted-foreground hover:text-foreground transition-colors">
                Terms of Service
              </NavLink>
            </nav>
          </div>

          <div className="space-y-4">
            <p className="text-sm font-semibold">Get In Touch</p>
            <div className="flex flex-col space-y-2 text-sm">
              <a href="tel:862-777-2808" className="flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors">
                <Phone size={16} />
                <span>862-777-2808</span>
              </a>
              <a href="mailto:brandon@leafrushmarketing.com" className="flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors">
                <Mail size={16} />
                <span>brandon@leafrushmarketing.com</span>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 border-t pt-8">
          <p className="text-center text-sm text-muted-foreground">
            © {new Date().getFullYear()} Leaf Rush Marketing. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
